import { api } from '../api/client';

import { API_TAG_URL } from '../utils';

/**
 * THE IMPACT REPORT (docs/plans/tags.md §3.2, ruled d33, d37, d38; keepr-api
 * docs/SCHEMA.md § The impact report; build step T4d). Before ANY tag is
 * deleted — a tag's Delete…, an item tag turned off with both kinds of
 * application removed, a card's item tags turned off the same way — the
 * person sees what refers to it, each entry with a link, and chooses
 * **Remove for me** or **Leave it**.
 *
 * `GET /api/tags/{id}/references` → `{ references: [TagReference], truncated }`
 * (500 at most), scoped to what the caller may see: their OWN pins and
 * personal filters, layouts, notifications and multi add forms, and — to a
 * manager of the collection each lives in — the collection's filters, rules,
 * notifications, card worklists, layout blocks, driven filters, multi add
 * seeds and saved exports. Never another person's (d37). One 404 for a tag
 * the caller cannot read.
 *
 * A card's whole report is services/itemTags.js getCardItemTagReferences.
 */
export async function getTagReferences(tagId) {
	const { data } = await api.get(`${API_TAG_URL(tagId)}/references`);
	return {
		references: Array.isArray(data?.references) ? data.references : [],
		truncated: Boolean(data?.truncated),
	};
}
